// AdminLogin.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AdminLogin.css';
import './App.css';
import { IoMdArrowBack } from "react-icons/io";

function AdminLogin() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const login = async (username, password) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/readLogin`, { username, password });
            const result = response.data.success;
            if (result === true) {
                localStorage.setItem("currentuser", username);
                navigate('/adminPortal');
            } else {
                window.alert("Username and password do not match");
            }

        } catch (error) {
            console.error('Error fetching formData:', error.message);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        login(username.trim(), password.trim());
    };

    return (
        <div className="container">

            <div className="login-form-container">
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="username">Username:</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Password: </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button type="submit">Login</button>
                </form>
            </div>
        </div>
    );
}

export default AdminLogin;
